export default "__VITE_ASSET__KZHTiB05__"